import { useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useCurrencyFormat } from '../../../hooks/utils/useCurrencyFormat';
import useModal from '../../../hooks/utils/useModal';
import Payment from './Payment';

const Trigger = ({ campaign, campaignId, foundation, foundationId }) => {
  const [amount, setAmount] = useState('');
  const [recurrence, setRecurrence] = useState('Solo una vez');
  const recurrenceList = ['Solo una vez', 'Mensualmente'];
  const amountOptions = [20000, 50000, 80000, 100000, 200000, 500000];
  const { openModal, isModalOpen, closeModal } = useModal();
  const currencyFormat = useCurrencyFormat();

  const handlePaymentClick = (selectedAmount) => {
    const validAmount =
      selectedAmount && selectedAmount >= 5000 ? selectedAmount : 5000;
    setAmount(validAmount);
    openModal();
  };

  return (
    <>
      <Payment
        campaign={campaign ? campaign.toLowerCase() : ''}
        campaignId={campaignId}
        foundation={foundation}
        foundationId={foundationId}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        amount={amount}
        recurrence={recurrence}
      />
      <button
        onClick={handlePaymentClick}
        className='payment btn'>
        Dona ya
      </button>
      <div className='description-payment-container'>
        <h4>¡Quiero donar!</h4>
        <div className='selectables'>
          <div className='group'>
            {recurrenceList.map((item) => (
              <button
                key={item}
                className={`btn selectable multiple ${
                  recurrence === item && 'active'
                }`}
                onClick={() => setRecurrence(item)}>
                {item}
              </button>
            ))}
          </div>
        </div>
        <div className='amount-options'>
          {amountOptions.map((item) => (
            <button
              key={item}
              className='btn selectable '
              onClick={() => handlePaymentClick(item)}>
              {currencyFormat(item)}
            </button>
          ))}
        </div>
        <div className='custom-amount'>
          <label htmlFor=''>Monto personalizado</label>
          <NumericFormat
            value={amount}
            thousandSeparator={true}
            prefix={'$'}
            decimalScale={0}
            allowNegative={false}
            className='money-input'
            placeholder='min $5.000'
            onValueChange={(values) => {
              const { value } = values;
              setAmount(Number(value));
            }}
          />
        </div>
        <button
          className='btn secondary donate'
          onClick={() => handlePaymentClick(amount)}>
          Dona Ya!
        </button>
      </div>
    </>
  );
};

export default Trigger;
